var DbHelper, MdaTableDoc, MdaTopicDoc, MdgQuestionDoc, MiniDsDoc, OverarchingQuestionDoc, QUESTION_DOC_BY_TYPE, QuestionDoc, QuestionsStatusesActions, W, alt, appUtils, errorHandler, errorHandlerWithMsg, generateActions, mediator, _ref;

alt = require('alt');

appUtils = require('lib/app_utils');

DbHelper = require('base/lib/db_helper');

_ref = require('lib/app_utils'), errorHandler = _ref.errorHandler, errorHandlerWithMsg = _ref.errorHandlerWithMsg;

generateActions = require('actions/utils/generate_actions');

mediator = require('mediator');

QuestionsStatusesActions = require('actions/questions_statuses_actions');

OverarchingQuestionDoc = require('lib/db_docs/overarching_question_doc');

MdgQuestionDoc = require('lib/db_docs/mdg_question_doc');

MiniDsDoc = require('lib/db_docs/mini_ds_doc');

MdaTableDoc = require('lib/db_docs/mda_table_doc');

MdaTopicDoc = require('lib/db_docs/mda_topic_doc');

QuestionDoc = require('lib/db_docs/question_doc');

QUESTION_DOC_BY_TYPE = {
  miniDocument: MiniDsDoc,
  mdaTable: MdaTableDoc,
  mdaTopic: MdaTopicDoc,
  mdaHandout: MiniDsDoc,
  mdgQuestion: MdgQuestionDoc,
  regular: QuestionDoc
};

W = require('when');

module.exports = generateActions({
  autoGenerate: ['closeCreateQuestionInLaserDialog', 'downloadDataFromLaserComplete', 'openCreateQuestionInLaser', 'setSelectedQuestions', 'syncingComplete'],
  name: 'LimitsActions',
  actions: {
    syncWithLaser: function(questionIds) {
      var projectId, questions;
      this.dispatch();
      projectId = mediator.project.id;
      questions = alt.stores.QuestionsStore.getQuestionsByIds(questionIds);
      questionIds = questionIds.filter(function(questionId) {
        return questions.getIn([questionId, 'laserProjectId'], null);
      });
      return fetch("" + (DbHelper.getBackendUrl()) + "/laser/" + projectId + "/_bulk_sync_status", {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          questionIds: questionIds.toJS()
        })
      })["catch"](function(error) {
        return errorHandlerWithMsg(error, $.t('laser:create_question_dialog.error.sync_with_laser'));
      })["finally"](this.actions.syncingComplete);
    },
    downloadDataFromLaser: function(questionId) {
      var projectId;
      this.dispatch(questionId);
      projectId = mediator.project.id;
      return fetch("" + (DbHelper.getBackendUrl()) + "/laser/" + projectId + "/" + questionId + "/_download_extraction_data", {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(function(response) {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error($.t('laser:create_question_dialog.error.download_data'));
        }
      }).then(function() {
        return QuestionsStatusesActions.updateQuestionStatus(projectId, questionId, 'laserStatus', 'data_downloaded');
      })["catch"](function(error) {
        return errorHandlerWithMsg(error, $.t('laser:create_question_dialog.error.download_data'));
      })["finally"]((function(_this) {
        return function() {
          return _this.actions.downloadDataFromLaserComplete(questionId);
        };
      })(this));
    },
    createQuestionsInLaser: function(questionIds) {
      var Doc, projectId, questionType;
      this.dispatch();
      projectId = mediator.project.id;
      questionType = mediator.services.switches.isOn('mdgTables') ? 'mdgQuestion' : 'regular';
      Doc = QUESTION_DOC_BY_TYPE[questionType];
      return fetch("" + (DbHelper.getBackendUrl()) + "/laser/" + projectId + "/_bulk_create", {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          questionIds: _.uniq(questionIds.toJS())
        })
      }).then(function(response) {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error($.t('laser:create_question_dialog.error.create_questions'));
        }
      }).then(function(_arg) {
        var projects;
        projects = _arg.projects;
        return W.all(_.map(projects, function(pId, questionId) {
          return QuestionsStatusesActions.updateQuestionStatus(projectId, questionId, 'laserStatus', 'project_created');
        }));
      })["catch"](function(error) {
        return appUtils.errorHandlerWithMsg(error, $.t('laser:create_question_dialog.error.create_questions'));
      })["finally"]((function(_this) {
        return function() {
          return _this.actions.closeCreateQuestionInLaserDialog();
        };
      })(this));
    }
  }
});
